/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SwaggerResourceOperation {
    getFixupPrototypeFunction() { return SwaggerResourceOperation.fixupPrototype; }

    static newInstance(model: Partial<SwaggerResourceOperation>): SwaggerResourceOperation {
        let obj = Object.assign(new SwaggerResourceOperation(), model);
        SwaggerResourceOperation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SwaggerResourceOperation>): SwaggerResourceOperation {
        if (!model) return null;
        return SwaggerResourceOperation.newInstance(<SwaggerResourceOperation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SwaggerResourceOperation) {
        if (!obj) return;

        models.SwaggerResourceOperation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SwaggerResourceOperation): boolean {
        Object.setPrototypeOf(obj, SwaggerResourceOperation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the Operation
     */
    id: string;

    /**
     * Name of the Operation
     */
    name: string;

    /**
     * Operation Id of the resource
     */
    operation_id: string;

    /**
     * Activity Type
     */
    activity_type: string;

    /**
     * Default Activity Flag
     */
    is_default: boolean;

}
